// eslint-disable-next-line camelcase
export const reset_cache = {
    text: 'Ваши куки и кэш успешно удалены.',
    link_text: 'Перейти на главную'
};
